import _ from 'lodash';

const quizTypes = {
  SCORE:              'score',
  CATEGORY_MATCH:     'categorymatch',
  CATEGORY_INTERSECT: 'categoryintersect', //used for MX experiences
  PRODUCT_FEED:       'productfeed', //used for shopify and adobe experiences
};

quizTypes.ALL = _.values(quizTypes);

export default quizTypes;
